module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Variações do produto " + _vm._s(_vm.product.title))]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, _vm._l((_vm.product.variations), function(variation) {
    return _c('div', {
      staticClass: "l-row variation"
    }, [_c('div', {
      staticClass: "l-col-2@md img-product"
    }, [_c('img', {
      attrs: {
        "src": variation.images[0],
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "l-col-10@md"
    }, [_c('div', {
      staticClass: "l-row"
    }, [_c('div', {
      staticClass: "l-col-4@md"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v("SKU")]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(variation.sku)) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "l-col-4@md"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v("EAN")]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(variation.ean)) + "\n              ")])]), _vm._v(" "), _vm._l((Object.keys(variation.attributes)), function(attributeName) {
      return _c('div', {
        staticClass: "l-col-4@md"
      }, [_c('div', {
        staticClass: "margin"
      }, [_c('strong', [_vm._v(_vm._s(_vm.$t((attributeName + ".label"))))]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(variation.attributes[attributeName])) + "\n              ")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "l-col-4@md"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('quantity.label')))]), _vm._v("\n                " + _vm._s(_vm._f("attribute")(variation.quantity)) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "l-col-4@md"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('price.label')))]), _vm._v(" "), _c('span', {
      staticClass: "oldPrice"
    }, [_vm._v(_vm._s(_vm._f("currency")(variation.previousPrice)) + " /")]), _vm._v(" "), _c('span', {
      staticClass: "newPrice"
    }, [_vm._v(_vm._s(_vm._f("currency")(variation.currentPrice)) + " ")])])]), _vm._v(" "), _c('div', {
      staticClass: "l-col-4@md"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('status.label')))]), _vm._v(" "), _c('span', {
      staticClass: "badge",
      class: variation.status
    }, [_vm._v(_vm._s(_vm.$t(((variation.status) + ".label"))))])])])], 2)])])
  }), 0), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn btn--info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("Fechar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41b4fbd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductProvide/List/VariationModal.vue
// module id = 3095
// module chunks = 0